import { useMutation } from '@tanstack/react-query'
import { UseBaseMutationOptions } from '@/core/api/type'
import { MessagingMutationKey } from '../../keys'
import MessagingService from '../services'
import {
	UpdateIntervalMessageDto,
	IntervalMessageTransactionModel,
} from '../../types'

interface UpdateIntervalMessageVariables {
	id: string
	data: UpdateIntervalMessageDto
}

function useMutationUpdateIntervalMessage(
	props?: UseBaseMutationOptions<
		IntervalMessageTransactionModel,
		UpdateIntervalMessageVariables
	>,
) {
	return useMutation({
		mutationKey: [MessagingMutationKey.UpdateIntervalMessage],
		mutationFn: ({ id, data }: UpdateIntervalMessageVariables) =>
			MessagingService.updateIntervalMessage(id, data),
		...props,
	})
}

export default useMutationUpdateIntervalMessage
